import { z } from "zod";
/**
 * How far a member got with a reset.
 *
 * `started` is first playback, not opening the card. The two were conflated
 * before this contract existed: tapping a reset marked the attention consumed,
 * so the only engagement the server ever saw was a tap. A tap is not a
 * wind-down, and comparing it against a microstep completion flatters the reset
 * for no reason other than opening a video being easier than doing something.
 */
export const ResetWatchPhase = z.enum(["started", "completed"]);
export const RecordResetWatchRequest = z.object({
    phase: ResetWatchPhase,
    /** Seconds of video actually played. Null when the player cannot report it. */
    secondsWatched: z.number().nonnegative().max(86_400).nullish(),
    /** Total length, so partial watches can be read as a fraction later. */
    durationSeconds: z.number().positive().max(86_400).nullish(),
    /**
     * The heartbeat decision that surfaced this reset, when it came from a card.
     * Absent for a reset the member found in the library on their own, which is a
     * real distinction: only the surfaced ones belong in the experiment.
     */
    decisionId: z.string().uuid().nullish(),
    /** Where the member watched it, for the same slicing as microstep surfaces. */
    surface: z.enum(["attention", "today", "library", "companion", "tools"]),
});
export const RecordResetWatchResponse = z.object({
    recorded: z.literal(true),
});
//# sourceMappingURL=resets.js.map